import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const ExprimeCharteCard = () => {
  return (
    <Card className="bg-gray-200/80 backdrop-blur-sm border border-black/10 shadow-sm">
      <CardHeader className="p-4 md:p-5 pb-2">
        <CardTitle className="text-lg md:text-xl font-bold text-[#1E3A8A]">
          L'académie d'Aix-Marseille avec le Lycée Cesar Baldaccini était le pilote du Concours Exprime la Charte
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 md:p-5 pt-0 space-y-3">
        <p className="text-sm md:text-[15px] text-[#1E3A8A] leading-snug">
          Le concours « Exprime la Charte ! » invite les élèves à s'approprier les valeurs républicaines 
          en réalisant une production collective (texte, affiche, vidéo, slam, dessin...) autour de la 
          Charte des Droits et Devoirs du Citoyen français.
        </p>
        <p className="text-sm md:text-[15px] text-[#1E3A8A] leading-snug">
          Le Lycée polyvalent César Baldaccini et son professeur d'Histoire Géographie, Gaelle Bertin, ont accepté d'être les pilotes du Concours "Exprime la Charte", qui a pour objectifs de permettre aux jeunes d'exprimer cette charte 
          à travers leurs propres codes : en mots, en images et/ou en musique. Il s'agit d'un travail d'équipe,
          où les participants expriment tout ou partie de la Charte en lien avec les valeurs fondamentales 
          de la République : Liberté, Égalité, Fraternité, Laïcité. 4 groupes d'élèves ont donc été formés et ont créé une œuvre qui sera présentée lors de la soirée du 25 novembre.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-2 pt-1">
          <Link 
            to="/blog#post9" 
            className="inline-flex items-center justify-center bg-[#1E3A8A] hover:bg-[#1E3A8A]/90 text-white px-4 py-2 rounded-lg font-medium text-sm transition-colors"
          >
            Plus d'info sur le concours et le projet pédagogique
            <ArrowRight className="ml-2" size={16} />
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};
